import "Layouts/default";

import { initCountdowns } from "Functions/countdown";

document.addEventListener("DOMContentLoaded", () => {
    initCountdowns();
});
